import { z } from 'zod';

export const MarkSchema = z.enum(['bold', 'italic', 'underline', 'code']);
export type Mark = z.infer<typeof MarkSchema>;

export const TextSpanSchema = z
  .object({
    text: z.string().min(1),
    marks: z.array(MarkSchema).default([]),
  })
  .strict();

export const TextContentSchema = z
  .object({
    spans: z.array(TextSpanSchema).min(1),
  })
  .strict();

export type TextContent = z.infer<typeof TextContentSchema>;

export function plainText(s: string): TextContent {
  if (!s) throw new Error('plain text must be non-empty');
  return { spans: [{ text: s, marks: [] }] };
}